export default __webpack_public_path__ + "static/media/img-about.ff7b7324.jpg";